/**
 * @generated SignedSource<<7f3d7c2d0613514fc3d8e7854889d8e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditScheduleDailyTaskImportanceQuery$variables = {
  routineId: string;
};
export type RoutineEditScheduleDailyTaskImportanceQuery$data = {
  readonly routine: {
    readonly activeVersion: {
      readonly tasks: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly title: string;
      }>;
    };
  } | null;
};
export type RoutineEditScheduleDailyTaskImportanceQuery = {
  response: RoutineEditScheduleDailyTaskImportanceQuery$data;
  variables: RoutineEditScheduleDailyTaskImportanceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "tasks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditScheduleDailyTaskImportanceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditScheduleDailyTaskImportanceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bda7921919877a147c27e15e46f4c2ac",
    "id": null,
    "metadata": {},
    "name": "RoutineEditScheduleDailyTaskImportanceQuery",
    "operationKind": "query",
    "text": "query RoutineEditScheduleDailyTaskImportanceQuery(\n  $routineId: ID!\n) {\n  routine(id: $routineId) {\n    activeVersion {\n      tasks {\n        __typename\n        id\n        title\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "782d8a1be7e4757c5fdba05937b72789";

export default node;
